import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100vh;
  padding: 16px 12px;
  background-color: ${(props) => props.theme.color.bg.secondary};

  @media print {
    display: none;
  }
`;

export const SidebarBrand = styled(Link)`
  padding: 0 12px;
  font-family: ${(props) => props.theme.font.title.family};
  font-size: ${(props) => props.theme.font.title.size.h4};
  font-weight: ${(props) => props.theme.font.title.weight.bold};
  color: ${(props) => props.theme.color.text.inverse};
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme.color.text.inverse};
  }
`;

export const SidebarNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const SidebarUser = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  font-size: ${(props) => props.theme.font.body.size.small};
  color: ${(props) => props.theme.color.text.inverse};
`;

export const BackLink = styled(Link)`
  font-size: 12px;
  color: ${(props) => props.theme.color.ui.primary};

  &:hover {
    color: ${(props) => props.theme.color.ui.primary};
  }
`;
